// Import dependencies
import React from 'react';
import axios from 'axios';
import cookie from 'js-cookie';
import { tokenize } from '../../../../helper';
import { displayUserAuthAuthorized, displayAffiliateNumber, displayDeviceType, navigateToMemberDetail } from '../uiAdminHelpers';

// Import styling
import './LoginHistoryPage.css';
import AdminNavbar from '../../../reusables/adminNavbar';

// Import config
import config from '../../../../configs/config.json';
const API_URL = config.API_URL;
const ADMIN_API_URL = API_URL + '/admin';

class LoginHistoryPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            history: [],
            stats: {
                daily: 0,
                monthly: 0,
                yearly: 0,
                total: 0,
            },
            sortKey: 'DATEDESC'
        }
    }

    componentDidMount() {
        // When the component (screen) mounts, check cooke if user is already logged in

        var token = cookie.get('token');
        var user_type = cookie.get('user-type');

        if (token) {
            if (user_type === 'admin') {
                // Admin authorized, query the back-end for the login history
                this.fetchLoginHistory();

            } else {
                // Not authorized, re-direct to admin log in page
                window.location.href = '/admin';
            }
        } else {
            // No token found, re-direct them to admin log in page
            window.location.href = '/admin'
        }
    }

    fetchLoginHistory = () => {
        axios.get(`${ADMIN_API_URL}/members/loginHistory?sort=${this.state.sortKey}`, tokenize())
            .then(response => {
                console.log(response.data);
                this.setState({ history: response.data.history, stats: response.data.stats });
            })
            .catch(error => {
                console.log('Failed to retrieve login history');
                console.log(error);
            })
    }

    handleSortRequest = (type) => {
        console.log('handleSortRequest(): ', type);
        switch (type) {
            case 'authorized':
                (this.state.sortKey === 'AUTHASC') ? this.setState({ sortKey: 'AUTHDESC' }) : this.setState({ sortKey: 'AUTHASC' });
                break;
            case 'date':
                (this.state.sortKey === 'DATEASC') ? this.setState({ sortKey: 'DATEDESC' }) : this.setState({ sortKey: 'DATEASC' });
                break;
            case 'affiliate':
                (this.state.sortKey === 'AFFILIATEASC') ? this.setState({ sortKey: 'AFFILIATEDESC' }) : this.setState({ sortKey: 'AFFILIATEASC' });
                break;
            case 'id':
                (this.state.sortKey === 'IDASC') ? this.setState({ sortKey: 'IDDESC' }) : this.setState({ sortKey: 'IDASC' });
                break;
            case 'name':
                (this.state.sortKey === 'NAMEASC') ? this.setState({ sortKey: 'NAMEDESC' }) : this.setState({ sortKey: 'NAMEASC' });
                break;
            case 'location':
                (this.state.sortKey === 'LOCATIONASC') ? this.setState({ sortKey: 'LOCATIONDESC' }) : this.setState({ sortKey: 'LOCATIONASC' });
                break;
            case 'ip':
                (this.state.sortKey === 'IPASC') ? this.setState({ sortKey: 'IPDESC' }) : this.setState({ sortKey: 'IPASC' });
                break;
            case 'device':
                (this.state.sortKey === 'DEVICEASC') ? this.setState({ sortKey: 'DEVICEDESC' }) : this.setState({ sortKey: 'DEVICEASC' });
                break;
            default:
                this.setState({ sortKey: 'DATEDESC' });
        }

        setTimeout(() => {
            this.fetchLoginHistory();
        }, 100)
    }

    render() {
        return (<div>
            <AdminNavbar />

            <h1 className='pageTitle'>Member Login History</h1>
            <p style={{ textAlign: 'center' }}>*Use <strong>CTR</strong> + <strong>F</strong> to search for member by name.</p>

            <div className='loginStatsContainer'>
                <div>Daily {this.state.stats.daily}</div>
                <div>Monthly {this.state.stats.monthly}</div>
                <div>Yearly {this.state.stats.yearly}</div>
                <div>Total {this.state.stats.total}</div>
            </div>

            <table className='table-striped generalTable loginHistoryTable'>
                <thead>
                    <tr>
                        <td onClick={() => this.handleSortRequest('authorized')}>Authorized</td>
                        <td onClick={() => this.handleSortRequest('date')}>Date</td>
                        <td onClick={() => this.handleSortRequest('affiliate')}>Affiliate Code</td>
                        <td onClick={() => this.handleSortRequest('id')}>Member ID</td>
                        <td onClick={() => this.handleSortRequest('name')}>Member Name</td>
                        <td onClick={() => this.handleSortRequest('location')}>Location</td>
                        <td onClick={() => this.handleSortRequest('ip')}>IP Address</td>
                        <td onClick={() => this.handleSortRequest('device')}>Device Type</td>
                    </tr>
                </thead>
                <tbody>
                    {

                        this.state.history.map((loginEvent, index) => {
                            // console.log(loginEvent);
                            // let date = loginEvent.login_datetime.slice(0,10);
                            // let time = loginEvent.login_datetime.slice(11,16)
                            let affiliate_code = loginEvent.affiliate_code;
                            if (affiliate_code !== null && affiliate_code < 10) {
                                affiliate_code = '0' + affiliate_code;
                            }

                            var memberID = loginEvent.db_member_id;

                            return (<tr key={index}>
                                <td onClick={() => navigateToMemberDetail(memberID)}>{displayUserAuthAuthorized(loginEvent.authorized)}</td>
                                <td onClick={() => navigateToMemberDetail(memberID)}>{loginEvent.login_datetime}</td>
                                <td onClick={() => navigateToMemberDetail(memberID)}>{displayAffiliateNumber(affiliate_code)}</td>
                                <td onClick={() => navigateToMemberDetail(memberID)}>{loginEvent.olli_member_id}</td>
                                <td onClick={() => navigateToMemberDetail(memberID)}>{loginEvent.name}</td>
                                <td onClick={() => navigateToMemberDetail(memberID)}>{loginEvent.location}</td>
                                <td onClick={() => navigateToMemberDetail(memberID)}>{loginEvent.ip_address}</td>
                                <td onClick={() => navigateToMemberDetail(memberID)}>{displayDeviceType(loginEvent.device_type)}</td>
                            </tr>)
                        })
                    }
                </tbody>
            </table>
        </div>)
    }
}

export default LoginHistoryPage;